import type { gsap } from 'gsap'

export type Gsap = typeof gsap

// GSAP stays out of the critical chunk: every animated piece of the landing waits on this one
// shared import. A failed import is forgotten, so a later mount retries.
let gsapLoad: Promise<Gsap> | null = null
export const loadGsap = () => (gsapLoad ??= import('gsap').then((m) => m.gsap, (err) => { gsapLoad = null; throw err }))
